// 导入组件，组件必须声明 name
import AceDataSourceTableSelector from "./src/main";
// 为组件添加 install 方法，用于按需引入
AceDataSourceTableSelector.install = function (Vue) {
  Vue.component(AceDataSourceTableSelector.name, AceDataSourceTableSelector);
};
export default AceDataSourceTableSelector;
